import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'zoneManagementExperience.list'

const ZoneManagementZoneListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ZoneManagementZoneListSlice
